import { handleActions } from 'redux-actions';
import { initialState } from './initialState';

const getCardIndex = (state, action) => {
  const currentOnboardingStep = state.wizardInfo[action.payload.step].cards;
  return currentOnboardingStep.findIndex(
    elem => elem.value === action.payload.value,
  );
};

const wizardFlow = handleActions(
  {
    SET_CARD_SELECTED: (state, action) => {
      const index = getCardIndex(state, action);
      const onboardingSteps = state.wizardInfo;
      const card = onboardingSteps[action.payload.step].cards[index];

      let updatedCards;
      let { cardSelected, questionResponse } = onboardingSteps[
        action.payload.step
      ];

      if (onboardingSteps[action.payload.step].isMultiple === false) {
        updatedCards = onboardingSteps[action.payload.step].cards.map(
          (content, i) =>
            i === index
              ? { ...content, isCardSelected: !content.isCardSelected }
              : { ...content, isCardSelected: false },
        );

        if (card.isCardSelected === false) {
          cardSelected.length = 0;
          questionResponse.length = 0;
          cardSelected.push(card.value);
          questionResponse.push(card.value);
        } else {
          cardSelected.length = 0;
          questionResponse.length = 0;
        }
      } else {
        updatedCards = onboardingSteps[action.payload.step].cards.map(
          (content, i) =>
            i === index
              ? { ...content, isCardSelected: !content.isCardSelected }
              : content,
        );

        if (card.isCardSelected === false) {
          cardSelected.push(card.value);
          questionResponse.push(card.value);
        } else {
          cardSelected = cardSelected.filter(content => content !== card.value);
          questionResponse = questionResponse.filter(
            content => content !== card.value,
          );
        }
      }

      onboardingSteps[action.payload.step].cards = updatedCards;
      onboardingSteps[action.payload.step].cardSelected = cardSelected;
      onboardingSteps[action.payload.step].questionResponse = questionResponse;

      return {
        ...state,
        wizardInfo: [...onboardingSteps],
      };
    },

    UNSELECT_ALL_CARDS_IN_STEP: (state, action) => {
      const onboardingSteps = state.wizardInfo;

      const unselectedCard = onboardingSteps[action.payload.step].cards.map(
        content => ({ ...content, isCardSelected: false }),
      );

      onboardingSteps[action.payload.step].cards = unselectedCard;
      onboardingSteps[action.payload.step].cardSelected = [];
      onboardingSteps[action.payload.step].questionResponse = [];

      return {
        ...state,
        wizardInfo: [...onboardingSteps],
      };
    },

    SAVE_FORM_INFO: (state, action) => ({
      ...state,
      formInfo: { ...state.formInfo, ...action.payload.value },
    }),

    RESET_WIZARD: state => {
      const wizardInfo = initialState.wizardInfo.map(step => ({
        ...step,
        cardSelected: [],
        questionResponse: [],
        cards: step.cards.map(content => ({
          ...content,
          isCardSelected: false,
        })),
      }));
      return {
        ...state,
        formInfo: initialState.formInfo,
        wizardInfo,
      };
    },
  },
  initialState,
);

export default wizardFlow;
export { initialState };



// WEBPACK FOOTER //
// ./src/store/reducers/OnboardingRedesign/index.js